import React, { useEffect, useState } from "react";

const TestApi = () => {
  const [apiData, setApiData] = useState(null);
  const [jsonData, setJsonData] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    // Fetch PHP API
    fetch("https://indodeftech.com/api/test.php")
      .then((res) => {
        if (!res.ok) throw new Error("API fetch failed");
        return res.json();
      })
      .then((data) => setApiData(data))
      .catch((err) => setError("API Error: " + err.message));

    // Fetch static JSON
    fetch("https://indodeftech.com/data/test.php")
      .then((res) => {
        if (!res.ok) throw new Error("JSON fetch failed");
        return res.json();
      })
      .then((data) => setJsonData(data))
      .catch((err) => setError("JSON Error: " + err.message));
  }, []);

  return (
    <div style={{ padding: "40px" }}>
      <h2>🔍 Test API & JSON Fetch</h2>

      {error && <p style={{ color: "red" }}>{error}</p>}

      <div style={{ marginTop: "20px" }}>
        <h3>📡 API (PHP)</h3>
        <pre>{apiData ? JSON.stringify(apiData, null, 2) : "Loading..."}</pre>
      </div>

      <div style={{ marginTop: "20px" }}>
        <h3>📄 JSON (Static File)</h3>
        <pre>{jsonData ? JSON.stringify(jsonData, null, 2) : "Loading..."}</pre>
      </div>
    </div>
  );
};

export default TestApi;
